module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/zh-hant_2-71e37989aa8492e66368a9cace9cd8ab.jpg";